import clsx from "clsx";
import { GenericTableData } from "gen/model/genericTableData";
import { DataTable } from "shared/components/table/data/DataTable";
import { getRootGenericTableColumFromAgColumn } from "shared/components/table/data/DataTableUtils";

export const EqualizationPreviewTable: React.FC<{
  tableData: GenericTableData;
}> = ({ tableData }) => (
  <DataTable
    data={tableData}
    sx={{
      [".ag-header-row-column-group:first-of-type " +
      ".ag-header-group-cell " +
      ".mb-header-cell-comp"]: {
        bg: "white",
        px: "8px !important",
        justifyContent: "flex-start !important",
        "& .mb-header-cell-comp-title": {
          color: "black",
        },
      },
      ".mb-equalization-totals": {
        bg: "primary.50 !important",
        color: "primary.600",
        "&.mb-cell-value-type-money": {
          ".mb-header-cell-comp-title[data-currency-symbol]": {
            _after: {
              color: "primary.400",
            },
          },
        },
      },
    }}
    headerOrCellClass={(props) =>
      clsx({
        "mb-equalization-totals":
          ("columnGroup" in props &&
            props.columnGroup?.getGroupId() ===
              "current_equalization_totals") ||
          props.column?.getColId() === "current_equalization_totals" ||
          getRootGenericTableColumFromAgColumn(props.column)?.id ===
            "current_equalization_totals",
      })
    }
  />
);
